import { Component }                  from '@angular/core';
import { MatDialogRef, MatSnackBar }  from '@angular/material';
import { UploadService }              from '../shared/upload.service';
import { Globals }                    from './../common/globals';

@Component({
  selector: 'sa-product-import-dialog',
  template: require('./product-import-dialog.component.html'),
  styles: [require('./product-import-dialog.component.scss')]
})
export class ProductImportDialogComponent {

  public model: any = {
    delimiter: 'semicolon',
    importType: 'dateImport',
    dateFrom: null,
    dateTo: null,
    dateFromValue: null,
    dateToValue: null,
    hasCaption: true
  };
  private fileUploaded = false;

  private importRunning = false;
  public errors: string[] = [];

  public delimiterVal = () => {
    if (this.model.delimiter === 'semicolon') {
      return ';';
    }
  }

  constructor(
    public dialogRef: MatDialogRef<ProductImportDialogComponent>,
    private uploadService: UploadService,
    public globals: Globals,
    private snackbar: MatSnackBar
  ) {
  }

  productCsvUploaded(file) {
    this.model.csvFile = file;
    this.fileUploaded = true;
  }

  processCsvImport() {
    this.errors = [];
    this.importRunning = true;

    if (!this.model.csvFile) {
      this.errors.push('CSV soubor pro import nebyl zadán.');
    }

    if (this.errors.length > 0) {
      this.importRunning = false;
      return;
    }
    let imgRequest = this.uploadService.makeFileRequest('/api/product/uploadcsv',
                                                        [],
                                                        [this.model.csvFile]);
    imgRequest.subscribe(
      res => {
          if (res.length > 0) {
            let jsonRes = JSON.parse(res);
            let errorList = '';

            if (jsonRes.errorLines.length > 0) {
              let counter = 1;
              jsonRes.errorLines.forEach(element => {
                errorList += counter.toString() + '# ' + element + '\n';
                counter++;
              });
            }

            this.snackbar.open('Naimportováno ' + (jsonRes.total - jsonRes.errors) +
                              ' z ' + jsonRes.total + ' záznamů.' +
                              ((jsonRes.errors > 0) ? ' Neplatné záznamy byly vynechány [' + jsonRes.errors + '].' : ''),
                              'Zavřít', {duration: 10000});
            this.dialogRef.close(errorList);
          }
      },
      error => {
        this.errors.push('Nepodařilo se importovat CSV soubor.');
        if (error.length > 0) {
          let jsonRes = JSON.parse(error);
          this.errors.push(jsonRes.Message);
        }
      },
      () => {
        this.importRunning = false;
      });
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/product-import-dialog/product-import-dialog.component.ts